import { useState } from 'react'
import FsLightbox from 'fslightbox-react'


export default function ImageStrip() {
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1,
    })

    const images = [
        '01.jpeg',
        '02.jpeg',
        '03.jpeg',
        '04.jpeg',
        '05.jpeg',
        '06.jpeg',
    ]

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number,
        })
    }

    return (
        <>
            <div className="grid lg:grid-cols-6 grid-cols-3 lg:mt-60 mt-16">
                {images.map((image, idx) => (
                        <img
                            key={idx}
                            onClick={() => openLightboxOnSlide(idx + 1)}
                            src={`/images/esterni/${image}`}
                            className="cursor-pointer"
                            alt={image}
                        />
                    ),
                )}
            </div>
            <FsLightbox
                toggler={lightboxController.toggler}
                sources={[
                    '/images/esterni/01.jpeg',
                    '/images/esterni/02.jpeg',
                    '/images/esterni/03.jpeg',
                    '/images/esterni/04.jpeg',
                    '/images/esterni/05.jpeg',
                ]}
                slide={lightboxController.slide}
            />
        </>
    )
}
